import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { replaceUrlParam } from "../common/utils";

import { useHistory } from "react-router-dom";
import clsx from "clsx";

import { Route, Switch } from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import ListRouter from "./ListRouter";

import ProductContainer from "./ProductContainer";
import BulkUploadHistory from "../features/products/BulkUploadHistory";
import AccountContainer from "./AccountContainer";
import UsersContainer from "../features/users/UsersContainer";
import Reports from "./Reports";
// import CustomSnackbar from '../features/snackbar/CustomSnackbar';
import CategoriesContainer from "../features/categories/CategoriesContainer";
import BrandsContainer from "../features/brands/BrandsContainer";
import SuppliersContainer from "../features/suppliers/SuppliersContainer";
import ClientsContainer from "../features/clients/ClientsContainer";
import AvatarMenu from "./AvatarMenu";
import ProductListUpdate from "../features/products/ProductListUpdate";
import OrdersContainer from "../features/orders/OrdersContainer";
import ClaimsContainer from "../features/claims/ClaimsContainer";
import UserPointsContainer from "../features/userPoints/UserPointsContainer";
import ClientUsersContainer from "../features/clientUsers/ClientUsersContainer";
import InvoicesContainer from "../features/invoices/InvoicesContainer";
import PurchaseOrdersContainer from "../features/purchaseOrders/PurchaseOrdersContainer";
import OrderProductsContainer from "../features/purchaseOrders/OrderProductsContainer";
import CouriersContainer from "../features/couriers/CouriersContainer";
import AverageMargin from "../features/reports/AverageMargin";
import ProductsOrdered from "../features/reports/ProductsOrdered";
import BottomBar from "../features/snackbar/BottomBar";

import {
  fetchClients,
  selectClients,
  getFullList as getFullClientsList,
} from "../features/clients/clientsSlice";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  // #42494E; light blue
  // #131f47; dark blue
  // #ed5e9d; pink

  root: {
    display: "flex",
    flexGrow: 1,
    minWidth: "100%",
  },
  appBar: {
    // backgroundColor: '#131f47',
    backgroundColor: "#42494E",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  logout: {
    // border: '1px solid #fff',
    color: "#FFF",
    fontWeight: "bold",
    marginLeft: "auto,",
    position: "absolute",
    right: 15,
  },
  title: {
    flexGrow: 1,
    textAlign: "left",
    display: "flex",
  },
}));

export default function CoreContainer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const { clients, clientsList, clientsAmount } = useSelector(selectClients);

  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  let jwtToken = localStorage.getItem("coreToken");
  if (!jwtToken) {
    localStorage.removeItem("coreUser");
    localStorage.removeItem("coreToken");
    history.push("/signin");
  }

  if (props.location.pathname === "/") {
    history.push("/products");
  }

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            <img
              src="/ps-logo-new.png"
              style={{ maxWidth: "13rem", maxHeight: 50, height: 50 }}
              alt="logo"
            />{" "}
          </Typography>
          {/* <Avatar>TD</Avatar>
          <Button className={classes.logout}>LOGOUT</Button> */}
          <BottomBar />
          <AvatarMenu />
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <ListRouter open={open} />
      </Drawer>
      <div className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          <Route path="/account" component={AccountContainer} />
          <Route path="/users" component={UsersContainer} />
          <Route path="/products/all" component={ProductListUpdate} />
          <Route path="/products/new" component={ProductContainer} />
          <Route path="/products/upload" component={BulkUploadHistory} />
          <Route path="/products/edit" component={ProductContainer} />
          <Route path="/products" component={ProductListUpdate} />
          <Route path="/reports/orders" component={ProductsOrdered} />
          <Route path="/reports/average-margin" component={AverageMargin} />
          {/* <Route path="/reports" component={Reports} /> */}
          <Route path="/categories" component={CategoriesContainer} />
          <Route path="/brands" component={BrandsContainer} />
          <Route path="/suppliers" component={SuppliersContainer} />
          {/* <Route path="/couriers" component={Couriers} /> */}
          <Route path="/clients" component={ClientsContainer} />
          <Route path="/orders" component={OrdersContainer} />
          <Route path="/claims" component={ClaimsContainer} />
          <Route path="/user-points" component={UserPointsContainer} />
          <Route path="/client-users" component={ClientUsersContainer} />
          <Route path="/invoices" component={InvoicesContainer} />
          <Route path="/purchase-orders" component={PurchaseOrdersContainer} />
          <Route path="/order-products" component={OrderProductsContainer} />
          <Route path="/couriers" component={CouriersContainer} />
        </Switch>
      </div>
    </div>
  );
}
